import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchLocationForm() {
  const navigate = useNavigate();
  const [lieu, setLieu] = useState("");
  const [dateDebut, setDateDebut] = useState("");
  const [heureDebut, setHeureDebut] = useState("10:00");
  const [dateFin, setDateFin] = useState("");
  const [heureFin, setHeureFin] = useState("10:00");
  const [restitutionMemeEndroit, setRestitutionMemeEndroit] = useState(true);
  const [conducteurAgeValide, setConducteurAgeValide] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/locations", {
      state: {
        lieu,
        dateDebut,
        heureDebut,
        dateFin,
        heureFin,
        restitutionMemeEndroit,
        conducteurAgeValide,
      },
    });
  };

  return (
    <div className="container my-5 py-4 px-4 bg-light rounded shadow">
      <h2 className="text-center mb-4 text-primary">
        Réservez votre voiture en <span className="text-success">3 minutes</span>
      </h2>

      <form onSubmit={handleSubmit} className="row g-4">
        <div className="col-md-6">
          <label className="form-label fw-bold">📍 Lieu de prise en charge</label>
          <input
            type="text"
            className="form-control"
            placeholder="Ex: Lomé Aéroport (LFW)"
            value={lieu}
            onChange={(e) => setLieu(e.target.value)}
            required
          />
        </div>

        <div className="col-md-3">
          <label className="form-label fw-bold">📅 Date de début</label>
          <input
            type="date"
            className="form-control"
            value={dateDebut}
            onChange={(e) => setDateDebut(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label fw-bold">🕙 Heure de début</label>
          <input
            type="time"
            className="form-control"
            value={heureDebut}
            onChange={(e) => setHeureDebut(e.target.value)}
            required
          />
        </div>

        <div className="col-md-3">
          <label className="form-label fw-bold">📅 Date de fin</label>
          <input
            type="date"
            className="form-control"
            value={dateFin}
            onChange={(e) => setDateFin(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label fw-bold">🕙 Heure de fin</label>
          <input
            type="time"
            className="form-control"
            value={heureFin}
            onChange={(e) => setHeureFin(e.target.value)}
            required
          />
        </div>

        <div className="col-md-6 d-flex flex-column justify-content-center">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={restitutionMemeEndroit}
              onChange={(e) => setRestitutionMemeEndroit(e.target.checked)}
              id="restitution"
            />
            <label className="form-check-label" htmlFor="restitution">
              Restitution au même endroit
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={conducteurAgeValide}
              onChange={(e) => setConducteurAgeValide(e.target.checked)}
              id="conducteurAge"
            />
            <label className="form-check-label" htmlFor="conducteurAge">
              Le conducteur a-t-il entre 26 et 69 ans ?
            </label>
          </div>
        </div>

        <div className="col-12 text-center mt-4">
          <button type="submit" className="btn btn-success btn-lg px-5">
            Rechercher
          </button>
        </div>
      </form>
    </div>
  );
}
